import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class ConnectedAccountsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.disconnectingSteam = false;
    this.disconnectingDiscord = false;
    this.accounts = null;
    this.error = null;
    this.loadAccounts();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Connected Accounts');
    app.setTitleCount(0);
  }
  loadAccounts() {
    this.loading = true;
    this.error = null;
    return app.request({
      method: 'GET',
      url: `${app.forum.attribute('baseUrl')}/hideout/accounts/status`
    }).then(response => {
      this.accounts = response;
    }).catch(error => {
      console.error(error);
      this.error = 'Connected account information could not be loaded.';
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  disconnectSteam() {
    const confirmed = window.confirm('Disconnect this Steam account from your Hideout account?');
    if (!confirmed || this.disconnectingSteam) {
      return;
    }
    this.disconnectingSteam = true;
    this.error = null;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('baseUrl')}/hideout/steam/disconnect`,
      body: {}
    }).then(() => {
      window.location.assign(`${app.forum.attribute('baseUrl')}/hideout/sso/start`);
    }).catch(error => {
      console.error(error);
      this.error = 'Steam could not be disconnected. Please try again.';
    }).finally(() => {
      this.disconnectingSteam = false;
      m.redraw();
    });
  }
  disconnectDiscord() {
    const confirmed = window.confirm('Disconnect this Discord account from your Hideout account?');
    if (!confirmed || this.disconnectingDiscord) {
      return;
    }
    this.disconnectingDiscord = true;
    this.error = null;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('baseUrl')}/hideout/discord/disconnect`,
      body: {}
    }).then(() => {
      window.location.assign(`${app.forum.attribute('baseUrl')}/hideout/sso/start`);
    }).catch(error => {
      console.error(error);
      this.error = 'Discord could not be disconnected. Please try again.';
    }).finally(() => {
      this.disconnectingDiscord = false;
      m.redraw();
    });
  }
  view() {
    if (!app.session.user) {
      return m(PageStructure, {
        className: "HideoutConnectedAccountsPage"
      }, m("div", {
        className: "HideoutAccountsPanel"
      }, m("h2", null, "Login required"), m("p", null, "You must log in before managing connected accounts.")));
    }
    return m(PageStructure, {
      className: "HideoutConnectedAccountsPage",
      loading: this.loading
    }, m("div", {
      className: "HideoutAccountsHeader"
    }, m("div", null, m("span", {
      className: "HideoutEyebrow"
    }, "THE HIDEOUT"), m("h1", null, "Connected Accounts"), m("p", null, "Link your gaming and community identities to one verified Hideout account."))), this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "HideoutAccountsPanel"
    }, false && m("div", {
      className: "HideoutAccountError"
    }, this.error), this.steamCard(), this.discordCard(), m("div", {
      className: "HideoutAccountNotice"
    }, "Your connected account details are used for server access, rankings, staff authorization, and community integrations.")));
  }
  steamCard() {
    const steam = this.accounts?.steam;
    const connected = steam?.connected === true;
    return m("section", {
      className: connected ? 'HideoutAccountCard HideoutAccountCard--connected' : 'HideoutAccountCard'
    }, m("div", {
      className: "HideoutAccountIcon HideoutSteamIcon"
    }, m("i", {
      className: "fab fa-steam"
    })), m("div", {
      className: "HideoutAccountDetails"
    }, m("div", {
      className: "HideoutAccountTitle"
    }, m("h2", null, "Steam"), m("span", {
      className: connected ? 'HideoutStatus HideoutStatus--connected' : 'HideoutStatus'
    }, connected ? 'Connected' : 'Not connected')), connected ? m("div", null, m("p", {
      className: "HideoutAccountIdentifier"
    }, "SteamID64: ", steam.steamId64), steam.verifiedAt && m("p", {
      className: "HideoutAccountVerified"
    }, "Verified account"), m("div", {
      className: "HideoutAccountActions"
    }, m("a", {
      className: "Button Button--primary",
      href: steam.profileUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "View Steam profile"), m(Button, {
      className: "Button",
      loading: this.disconnectingSteam,
      disabled: this.disconnectingSteam || this.disconnectingDiscord,
      onclick: () => this.disconnectSteam()
    }, "Disconnect"))) : m("div", null, m("p", null, "Connect Steam to verify your identity for CS2 servers, rankings, and staff access."), m("a", {
      className: "Button Button--primary",
      href: `${app.forum.attribute('baseUrl')}/hideout/steam/connect`
    }, m("i", {
      className: "fab fa-steam"
    }), " Connect Steam"))));
  }
  discordCard() {
    const discord = this.accounts?.discord;
    const connected = discord?.connected === true;
    const displayName = discord?.globalName || discord?.username || 'Discord account';
    return m("section", {
      className: connected ? 'HideoutAccountCard HideoutAccountCard--connected' : 'HideoutAccountCard'
    }, m("div", {
      className: "HideoutAccountIcon HideoutDiscordIcon"
    }, connected && discord.avatarUrl ? m("img", {
      className: "HideoutAccountAvatar",
      src: discord.avatarUrl,
      alt: `${displayName}'s Discord avatar`
    }) : m("i", {
      className: "fab fa-discord"
    })), m("div", {
      className: "HideoutAccountDetails"
    }, m("div", {
      className: "HideoutAccountTitle"
    }, m("h2", null, "Discord"), m("span", {
      className: connected ? 'HideoutStatus HideoutStatus--connected' : 'HideoutStatus'
    }, connected ? 'Connected' : 'Not connected')), connected ? m("div", null, m("p", {
      className: "HideoutAccountIdentifier"
    }, displayName), discord.username && discord.globalName && discord.username !== discord.globalName && m("p", {
      className: "HideoutAccountSecondary"
    }, "@", discord.username), discord.discordId && m("p", {
      className: "HideoutAccountSecondary"
    }, "Discord ID: ", discord.discordId), m("div", {
      className: "HideoutAccountActions"
    }, discord.profileUrl && m("a", {
      className: "Button Button--primary",
      href: discord.profileUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "View Discord profile"), m(Button, {
      className: "Button",
      loading: this.disconnectingDiscord,
      disabled: this.disconnectingDiscord || this.disconnectingSteam,
      onclick: () => this.disconnectDiscord()
    }, "Disconnect"))) : m("div", null, m("p", null, "Connect Discord for identity verification, community roles, supporter status, and staff access."), m("a", {
      className: "Button Button--primary HideoutDiscordButton",
      href: `${app.forum.attribute('baseUrl')}/hideout/discord/connect`
    }, m("i", {
      className: "fab fa-discord"
    }), " Connect Discord"))));
  }
}
flarum.reg.add('thehideout-core', 'forum/components/ConnectedAccountsPage', ConnectedAccountsPage);